import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../../Components/Sidebar/Sidebar';
import verificandoApp from '../../../FuncoesGerais/verificaApp';
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import { fetchStatusChamadoTodos, createStatusChamado, updateStatusChamado, deleteStatusChamado, duplicarStatusChamadoParaEmpresa } from '../../../api/cadastroChamados';
import { fetchEmpresas } from '../../../api/empresas';
import { ModalConfirm } from '../../Components/ModalSistema';
import CadastroFormDrawer from '../../Components/CadastroFormDrawer/CadastroFormDrawer';
import './statusChamado.css';

const isEmpresa1 = () => localStorage.getItem('empresa_id') === '1' || localStorage.getItem('isSoftbridge') === 'S';

function StatusChamado() {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [nome, setNome] = useState('');
    const [codigoLegado, setCodigoLegado] = useState('');
    const [ativo, setAtivo] = useState(1);
    const [ordem, setOrdem] = useState(0);
    const [finalizacao, setFinalizacao] = useState(0);
    const [mensagem, setMensagem] = useState('');
    const [busca, setBusca] = useState('');
    const [filtroAtivo, setFiltroAtivo] = useState('todos');
    const [formDrawerOpen, setFormDrawerOpen] = useState(false);
    const [showModalDuplicar, setShowModalDuplicar] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [empresaDestinoId, setEmpresaDestinoId] = useState('');
    const [empresasList, setEmpresasList] = useState([]);
    const [loadingDuplicar, setLoadingDuplicar] = useState(false);
    const [mensagemDuplicar, setMensagemDuplicar] = useState('');
    const [confirmExcluir, setConfirmExcluir] = useState({ show: false, itemId: null, itemNome: '' });
    const [confirmDuplicar, setConfirmDuplicar] = useState({ show: false, count: 0, nomeEmpresa: '' });

    const verificar = async () => {
        const resultado = await verificandoApp('ATENDENTE');
        if (!resultado) history.push('/');
    };

    const load = async () => {
        setLoading(true);
        verificandoToken();
        try {
            const list = await fetchStatusChamadoTodos();
            setData(list);
        } catch (e) {
            setMensagem('Erro ao carregar lista');
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        verificar();
        load();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const limparForm = () => {
        setId('');
        setNome('');
        setCodigoLegado('');
        setAtivo(1);
        setOrdem(0);
        setFinalizacao(0);
        setMensagem('');
    };

    const handleEdit = (item) => {
        setId(item.id);
        setNome(item.nome || '');
        setCodigoLegado(item.codigo_legado != null ? String(item.codigo_legado) : '');
        setAtivo(item.ativo != null ? Number(item.ativo) : 1);
        setOrdem(item.ordem != null ? Number(item.ordem) : 0);
        setFinalizacao(item.finalizacao != null && Number(item.finalizacao) ? 1 : 0);
        setMensagem('');
        setFormDrawerOpen(true);
    };

    const salvar = async () => {
        if (!nome || !String(nome).trim()) {
            setMensagem('Nome é obrigatório.');
            return;
        }
        if (codigoLegado === '' || codigoLegado === null || codigoLegado === undefined) {
            setMensagem('Código legado (valor SATSTA) é obrigatório.');
            return;
        }
        setMensagem('');
        verificandoToken();
        const body = {
            nome: nome.trim(),
            codigo_legado: Number(codigoLegado),
            ativo: Number(ativo),
            ordem: Number(ordem) || 0,
            finalizacao: finalizacao ? 1 : 0
        };
        try {
            if (id) {
                await updateStatusChamado(id, body);
            } else {
                await createStatusChamado(body);
            }
            limparForm();
            setFormDrawerOpen(false);
            load();
        } catch (e) {
            setMensagem(e?.response?.data?.message || 'Erro ao salvar.');
        }
    };

    const excluir = (itemId, itemNome) => {
        setConfirmExcluir({ show: true, itemId, itemNome });
    };

    const executarExcluir = async () => {
        const { itemId: itemIdToDelete } = confirmExcluir;
        setConfirmExcluir({ show: false, itemId: null, itemNome: '' });
        if (!itemIdToDelete) return;
        verificandoToken();
        try {
            await deleteStatusChamado(itemIdToDelete);
            load();
            if (id === itemIdToDelete) { limparForm(); setFormDrawerOpen(false); }
        } catch (e) {
            setMensagem(e?.response?.data?.message || 'Erro ao excluir.');
        }
    };

    const abrirModalDuplicar = async () => {
        setMensagemDuplicar('');
        setSelectedIds([]);
        setEmpresaDestinoId('');
        try {
            const list = await fetchEmpresas();
            setEmpresasList(Array.isArray(list) ? list.filter((e) => Number(e.id) !== 1) : []);
        } catch (e) {
            setMensagemDuplicar('Erro ao carregar empresas.');
        }
        setShowModalDuplicar(true);
    };

    const toggleSelecaoDuplicar = (itemId) => {
        setSelectedIds((prev) => (prev.includes(itemId) ? prev.filter((x) => x !== itemId) : [...prev, itemId]));
    };

    const selecionarTodosDuplicar = () => {
        const ids = filtrado.map((s) => s.id);
        setSelectedIds(ids.length === selectedIds.length ? [] : ids);
    };

    const solicitarConfirmacaoDuplicar = () => {
        const destId = Number(empresaDestinoId);
        if (!destId || selectedIds.length === 0) {
            setMensagemDuplicar('Selecione ao menos um item e a empresa destino.');
            return;
        }
        const emp = empresasList.find((e) => Number(e.id) === destId);
        const nomeEmpresa = emp ? emp.nome : `ID ${destId}`;
        setConfirmDuplicar({ show: true, count: selectedIds.length, nomeEmpresa });
    };

    const confirmarDuplicar = async () => {
        setConfirmDuplicar({ show: false, count: 0, nomeEmpresa: '' });
        const destId = Number(empresaDestinoId);
        if (!destId || selectedIds.length === 0) return;
        setLoadingDuplicar(true);
        setMensagemDuplicar('');
        verificandoToken();
        try {
            await duplicarStatusChamadoParaEmpresa(selectedIds, destId);
            setShowModalDuplicar(false);
            load();
        } catch (e) {
            setMensagemDuplicar(e?.response?.data?.error || e?.response?.data?.message || 'Erro ao duplicar.');
        } finally {
            setLoadingDuplicar(false);
        }
    };

    const porBusca = !busca.trim()
        ? data
        : data.filter((s) =>
            String(s.nome || '').toLowerCase().includes(busca.toLowerCase()) ||
            String(s.codigo_legado).includes(busca)
        );
    const filtrado = filtroAtivo === 'todos'
        ? porBusca
        : porBusca.filter((s) => (filtroAtivo === 'ativo' ? s.ativo : !s.ativo));

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado">
                    <div className="page-header">
                        <h1>Cadastro de Status de Chamado</h1>
                        <div className="toolbar flex-wrap">
                            <div className="input-group input-group-sm" style={{ maxWidth: 280 }}>
                                <input value={busca} onChange={(e) => setBusca(e.target.value)} type="text" className="form-control" placeholder="Pesquisar" />
                            </div>
                            <select value={filtroAtivo} onChange={(e) => setFiltroAtivo(e.target.value)} className="form-control form-control-sm" style={{ maxWidth: 140 }} title="Filtrar por status">
                                <option value="todos">Todos</option>
                                <option value="ativo">Ativos</option>
                                <option value="inativo">Inativos</option>
                            </select>
                            <button type="button" className="btn btn-primary btn-sm" onClick={() => { limparForm(); setFormDrawerOpen(true); }}>
                                Novo status
                            </button>
                            {isEmpresa1() && (
                                <button type="button" className="btn btn-outline-primary btn-sm" onClick={abrirModalDuplicar} title="Duplicar cadastros para outra empresa">
                                    Duplicar para outra empresa
                                </button>
                            )}
                        </div>
                    </div>
                    <CadastroFormDrawer
                        open={formDrawerOpen}
                        onClose={() => { limparForm(); setFormDrawerOpen(false); }}
                        title={id ? 'Editar status' : 'Novo status'}
                    >
                        <div className="cadastro-form-drawer-form">
                            <div className="form-group">
                                <label>Nome</label>
                                <input value={nome} onChange={(e) => setNome(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Código legado (SATSTA)</label>
                                <input type="number" value={codigoLegado} onChange={(e) => setCodigoLegado(e.target.value)} className="form-control form-control-sm" placeholder="Ex: 0, 10, 20..." />
                            </div>
                            <div className="form-group">
                                <label>Ordem</label>
                                <input type="number" value={ordem} onChange={(e) => setOrdem(e.target.value)} className="form-control form-control-sm" />
                            </div>
                            <div className="form-group">
                                <label>Ativo</label>
                                <select value={ativo} onChange={(e) => setAtivo(e.target.value)} className="form-control form-control-sm">
                                    <option value={1}>Sim</option>
                                    <option value={0}>Não</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <div className="form-check">
                                    <input type="checkbox" className="form-check-input" id="finalizacao" checked={!!finalizacao} onChange={(e) => setFinalizacao(e.target.checked ? 1 : 0)} />
                                    <label className="form-check-label" htmlFor="finalizacao">É finalização</label>
                                </div>
                                <small className="text-muted">Encerra o chamado (não aparece na listagem de abertos)</small>
                            </div>
                            {mensagem && <div className="alert alert-danger py-2 mb-2">{mensagem}</div>}
                            <div className="cadastro-form-drawer-form__actions">
                                <button onClick={() => { limparForm(); setFormDrawerOpen(false); }} type="button" className="btn btn-secondary btn-sm">Cancelar</button>
                                <button onClick={salvar} type="button" className="btn btn-primary btn-sm">Salvar</button>
                            </div>
                        </div>
                    </CadastroFormDrawer>
                    <div className="lista-wrapper">
                        {loading ? (
                            <p className="text-muted">Carregando...</p>
                        ) : (
                            <table className="table table-modern align-middle">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Nome</th>
                                        <th>Código (SATSTA)</th>
                                        <th>Ordem</th>
                                        <th>Ativo</th>
                                        <th>Finalização</th>
                                        <th width="120">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filtrado.length === 0 && !loading && (
                                        <tr><td colSpan="7" className="text-center text-muted">Nenhum status cadastrado.</td></tr>
                                    )}
                                    {filtrado.map((s) => (
                                        <tr key={s.id} className="table-row-clickable" onClick={() => handleEdit(s)}>
                                            <td>{s.id}</td>
                                            <td>{s.nome}</td>
                                            <td>{s.codigo_legado != null ? s.codigo_legado : '-'}</td>
                                            <td>{s.ordem != null ? s.ordem : '-'}</td>
                                            <td><span className={s.ativo ? 'badge-pill badge-ativo' : 'badge-pill badge-inativo'}>{s.ativo ? 'Sim' : 'Não'}</span></td>
                                            <td><span className={s.finalizacao ? 'badge-pill badge-ativo' : 'badge-pill badge-inativo'}>{s.finalizacao ? 'Sim' : 'Não'}</span></td>
                                            <td onClick={(e) => e.stopPropagation()}>
                                                <button type="button" className="btn btn-secondary btn-sm me-1" onClick={() => handleEdit(s)} title="Editar"><i className="fas fa-edit" /></button>
                                                <button type="button" className="btn btn-danger btn-sm" onClick={(e) => { e.stopPropagation(); excluir(s.id, s.nome); }} title="Excluir"><i className="fas fa-trash" /></button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>

                    {showModalDuplicar && (
                        <div className="modal-overlay" onClick={() => !loadingDuplicar && setShowModalDuplicar(false)}>
                            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                                <h5 className="mb-3">Duplicar status de chamado para outra empresa</h5>
                                <p className="text-muted small mb-2">Selecione os itens e a empresa destino. Apenas cadastros da empresa Softbridge (1) serão copiados.</p>
                                <div className="mb-3">
                                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={selecionarTodosDuplicar}>
                                        {filtrado.length > 0 && selectedIds.length === filtrado.length ? 'Desmarcar todos' : 'Selecionar todos'}
                                    </button>
                                </div>
                                <div className="mb-3" style={{ maxHeight: 200, overflowY: 'auto' }}>
                                    {filtrado.map((s) => (
                                        <div key={s.id} className="form-check">
                                            <input type="checkbox" className="form-check-input" id={`dup-status-${s.id}`} checked={selectedIds.includes(s.id)} onChange={() => toggleSelecaoDuplicar(s.id)} />
                                            <label className="form-check-label" htmlFor={`dup-status-${s.id}`}>{s.nome}</label>
                                        </div>
                                    ))}
                                    {filtrado.length === 0 && <span className="text-muted">Nenhum item na lista.</span>}
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Empresa destino</label>
                                    <select className="form-select form-select-sm" value={empresaDestinoId} onChange={(e) => setEmpresaDestinoId(e.target.value)}>
                                        <option value="">Selecione...</option>
                                        {empresasList.map((e) => (
                                            <option key={e.id} value={e.id}>{e.nome || `Empresa ${e.id}`}</option>
                                        ))}
                                    </select>
                                </div>
                                {mensagemDuplicar && <div className="alert alert-danger py-2 mb-2">{mensagemDuplicar}</div>}
                                <div className="d-flex justify-content-end gap-2">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={() => setShowModalDuplicar(false)} disabled={loadingDuplicar}>Cancelar</button>
                                    <button type="button" className="btn btn-primary btn-sm" onClick={solicitarConfirmacaoDuplicar} disabled={loadingDuplicar}>{loadingDuplicar ? 'Duplicando...' : 'Duplicar'}</button>
                                </div>
                            </div>
                        </div>
                    )}

                    <ModalConfirm
                        open={confirmExcluir.show}
                        onClose={() => setConfirmExcluir({ show: false, itemId: null, itemNome: '' })}
                        title="Excluir status"
                        message={`Excluir o status "${confirmExcluir.itemNome}"?`}
                        confirmLabel="Sim, excluir"
                        cancelLabel="Cancelar"
                        onConfirm={executarExcluir}
                        variant="danger"
                    />
                    <ModalConfirm
                        open={confirmDuplicar.show}
                        onClose={() => setConfirmDuplicar({ show: false, count: 0, nomeEmpresa: '' })}
                        title="Duplicar para empresa"
                        message={`Deseja duplicar ${confirmDuplicar.count} item(ns) para a empresa "${confirmDuplicar.nomeEmpresa}"?`}
                        confirmLabel="Sim, duplicar"
                        cancelLabel="Cancelar"
                        onConfirm={confirmarDuplicar}
                        variant="primary"
                    />
                </div>
            </main>
        </div>
    );
}

export default StatusChamado;
